export const essexWordPressAreas = [
  "Chelmsford",
  "Brentwood",
  "Braintree",
  "Colchester",
  "Basildon",
  "Southend-on-Sea",
  "Maldon",
  "Rayleigh",
  "Witham",
  "Harlow",
  "Epping",
]

export const wordpressSupportFaqs = [
  {
    question: "What is included in WordPress support and maintenance?",
    answer:
      "Our support can include WordPress core, theme and plugin updates, compatibility checks, backups, security reviews, troubleshooting, performance improvements and agreed content or development changes. We tailor the scope to the website rather than forcing every business into the same package.",
  },
  {
    question: "Do you provide WordPress support across Essex?",
    answer:
      "Yes. We support WordPress websites for businesses across Essex, including Chelmsford, Brentwood, Braintree, Colchester, Basildon, Southend-on-Sea, Maldon, Rayleigh, Witham, Harlow and Epping. We also work with organisations elsewhere in the UK.",
  },
  {
    question:
      "Can you take over support for a website built by another agency?",
    answer:
      "Yes. We normally begin with a technical review so we can understand the theme, plugins, hosting, integrations and any existing issues before agreeing the safest support plan.",
  },
  {
    question: "Can you help with an urgent WordPress problem?",
    answer:
      "Yes, subject to availability and access. We can investigate broken layouts, plugin conflicts, failed updates, form problems, hosting issues and other faults. We will explain the likely cause, the proposed fix and any longer-term recommendation before proceeding.",
  },
  {
    question: "Can you improve the speed of an existing WordPress website?",
    answer:
      "Yes. We investigate hosting, caching, images, scripts, plugins, themes and page structure to identify what is slowing the site down. We then prioritise changes according to their likely effect and the risk involved.",
  },
  {
    question: "Do you provide WordPress hosting and backups?",
    answer:
      "We can manage suitable WordPress hosting, SSL, staging environments and backup arrangements as part of an ongoing support service. The recommended setup depends on the size, traffic and functionality of your website.",
  },
  {
    question: "How often should WordPress plugins and core be updated?",
    answer:
      "Updates should be reviewed regularly and critical security releases should be assessed promptly. We check compatibility, take an appropriate backup and use staging where the risk or complexity of an update makes that sensible.",
  },
  {
    question: "Do you also provide ongoing WordPress development?",
    answer:
      "Yes. Alongside maintenance, we can deliver new landing pages, integrations, WooCommerce improvements, accessibility fixes and other planned development. Larger redesigns or new builds are handled through our WordPress development service.",
  },
]

export const wordpressDevelopmentFaqs = [
  {
    question: "Do you provide WordPress development services across Essex?",
    answer:
      "Yes. We work with businesses across Essex on bespoke WordPress websites, redesigns, WooCommerce development, integrations, performance improvements and ongoing support.",
  },
  {
    question: "Can you improve an existing WordPress website?",
    answer:
      "Yes. We can improve page structure, speed, user experience, accessibility, SEO foundations and conversion journeys without automatically recommending a complete rebuild.",
  },
  {
    question: "Do you build WooCommerce websites?",
    answer:
      "Yes. We build and improve WooCommerce stores, including product and category templates, checkout journeys, payment or fulfilment integrations and ongoing technical improvements.",
  },
  {
    question: "Can you integrate WordPress with other business systems?",
    answer:
      "Yes. We build API and workflow integrations between WordPress and suitable CRM, email, booking, payment and operational platforms. We scope authentication, data handling and failure recovery before development begins.",
  },
  {
    question: "Can you speed up a slow WordPress website?",
    answer:
      "Yes. We investigate image handling, caching, plugins, themes, scripts, hosting and page structure, then prioritise the changes most likely to improve real visitor experience.",
  },
  {
    question: "Can you help a WordPress website target Essex searches?",
    answer:
      "Yes. We can improve service architecture, page content, metadata, internal linking and technical foundations around genuine local search intent. Local pages should be useful and specific rather than duplicated for every town.",
  },
  {
    question: "How long does a WordPress project take?",
    answer:
      "Timing depends on the number of templates, content requirements, integrations and approval process. We provide a phased plan after discovery so responsibilities and milestones are clear.",
  },
  {
    question: "Can you support the website after launch?",
    answer:
      "Yes. Our WordPress support service can cover updates, backups, troubleshooting, performance work and planned improvements after launch.",
  },
  {
    question: "Do you only work with businesses in Chelmsford?",
    answer:
      "No. We work throughout Essex, including Brentwood, Braintree, Colchester, Basildon, Southend-on-Sea, Maldon, Rayleigh, Witham, Harlow and Epping, as well as with organisations elsewhere in the UK.",
  },
  {
    question: "Can you take over a WordPress project from another developer?",
    answer:
      "Yes. We begin by reviewing the codebase, hosting, plugins, integrations and outstanding requirements so we can identify risks and recommend a practical handover plan.",
  },
]
